<div class="label-editor">
  <div class="label-editor__field">
    <label class="label-editor__field-label">Text Area</label>
    <rich-textarea
      [initialContent]="initialText"
      placeholder=""
      [disabledFormats]="['list:ordered']"
      (contentChange)="onTextChange($event)">
    </rich-textarea>
  </div>
  <div class="label-editor__field">
    <label class="label-editor__field-label">Icon</label>
    <pdq-iconpicker
      [presetIconUrls]="presetIconUrls"
      [iconUrl]="iconUrlValue"
      [customIconUrl]="customIconUrlValue"
      (iconUrlChange)="onIconUrlChange($event)"
      (uploadCustomRequested)="onUploadCustomIcon()"
      (removeCustomRequested)="onRemoveCustomIcon()">
    </pdq-iconpicker>
  </div>
</div>
